import styled from "styled-components";
import Grid from "../../../grid";

export const Container = styled(Grid).attrs({ container: true })``;

export const Cell = styled(Grid).attrs({ item: true, xs: 6 })``;
